import { useState } from "react";
import EmergencyContactSC from "./emergency_contact.styles";

const EmergencyContact = ({ ref }) => {
    const [numberCopied, setNumberCopied] = useState(false);
    const handleCopy = (number) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(number);
            setNumberCopied(true);
            setTimeout(() => {
                setNumberCopied(false);
            }, 5000);
        } else {
            alert("Please copy the number manually: " + number);
        }
    };
    return <EmergencyContactSC>
        {/* Decorative Shapes */}
        {/* <div className="shape shape-left"></div>
        <div className="shape shape-top-right"></div>
        <div className="shape shape-bottom-right"></div> */}

        <div className="emergency-content" ref={ref}>
            {/* <div className="divider"></div> */}

            <h2 className='disable-text'>You Matter. We’re Here.</h2>

            <p className='disable-text'>
                Free 24×7 helplines for anxiety, emotional distress, panic attacks, and suicidal thoughts.
            </p>

            <div className="contact-number">
                <span onClick={() => { handleCopy("14416"); }}>14416</span> <br /><br /> or <br /><br />
                <span onClick={() => { handleCopy("18008914416"); }}>1800-89-14416</span>
            </div>
            <div className="know-more disable-text"
                onClick={() => window.open("https://telemanas.mohfw.gov.in/home", "_blank")}>
                To know more about Tele-MANAS Helpline, click here.
            </div>
            <div className="number-copied">
                {numberCopied ? "Number copied" : ""}
            </div>
        </div>
    </EmergencyContactSC>;
};

export default EmergencyContact;